export const MAX_DISPLAYED_COMMENTS_COUNT = 3;
export const POST_LINK_PATTERN = 'post://';
